<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-title class="aligned"><img [src]="compData[compMod].titleIcon" width="50px"><span>{{compData[compMod][rw].title}}</span></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
</ion-content>